import {useContext} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import {useLocation} from '@s-ui/react-router'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconCircleCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

import {useMessagingContext} from '../../useMessagingContext/index.js'

export const ConfirmCostsListTransactionModal = () => {
  const {state: routerState} = useLocation()
  const {i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const {costs = [], purchasePrice = 0, totalAmount = 0} = routerState || {}

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionConfirmCostsListModal-modalContainer">
        <MoleculeNotification
          alignItems={moleculeNotificationAlignItems.CENTER}
          autoClose={null}
          icon={<IconCircleCheck size="medium" />}
          position="relative"
          roundedCorners={moleculeNotificationBorderSizes.medium}
          show
          showCloseButton={false}
          showLeftIconMobile
          type={moleculeNotificationTypes.success}
          variation={moleculeNotificationVariations.positive}
        >
          {i18n.t('VEHICLE_TRANSACTION.BUYER_CHECK_COSTS_LIST.MODAL_CONFIRM.NOTIFICATION_TEXT')}
        </MoleculeNotification>
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-TransactionConfirmCostsListModal-modalChildren">
                  <div className="mt-TransactionConfirmCostsListModal-description">
                    {i18n.t('VEHICLE_TRANSACTION.BUYER_CHECK_COSTS_LIST.MODAL_CONFIRM.TEXT')}
                  </div>
                  <div className="mt-TransactionConfirmCostsListModal-priceWrapper">
                    <div className="mt-TransactionConfirmCostsListModal-adPrice">
                      <span className="mt-TransactionConfirmCostsListModal-adPriceLabel">
                        {i18n.t('VEHICLE_TRANSACTION.BUYER_CHECK_COSTS_LIST.MAIN_TEXT_PRICE_AGREED')}
                      </span>
                      <span className="mt-TransactionConfirmCostsListModal-adPriceValue">
                        {i18n.c(purchasePrice, 2)}
                      </span>
                    </div>
                    {costs.map(({amount, description}) => {
                      return (
                        <div className="mt-TransactionConfirmCostsListModal-adPrice">
                          <span className="mt-TransactionConfirmCostsListModal-adPriceLabel">{description}</span>
                          <span className="mt-TransactionConfirmCostsListModal-adPriceValue">{i18n.c(amount, 2)}</span>
                        </div>
                      )
                    })}
                    <div className="mt-TransactionConfirmCostsListModal-agreedPrice">
                      <span className="mt-TransactionConfirmCostsListModal-agreedPriceLabel">
                        <strong>{i18n.t('VEHICLE_TRANSACTION.BUYER_CHECK_COSTS_LIST.MAIN_TEXT_TOTAL')}</strong>
                      </span>
                      <span className="mt-TransactionConfirmCostsListModal-agreedPriceValue">
                        {i18n.c(totalAmount, 2)}
                      </span>
                    </div>
                  </div>
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.BUYER_CHECK_COSTS_LIST.MODAL_CONFIRM.TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
